exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".styles__editor___2U_HU {\n  border: solid 1px black;\n  padding: 1rem;\n}\n", "", {"version":3,"sources":["/./src/containers/PluginEditor/styles.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,cAAc;CACf","file":"styles.css","sourcesContent":[".editor {\n  border: solid 1px black;\n  padding: 1rem;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"editor": "styles__editor___2U_HU"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&sourceMap&importLoaders=2&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/containers/PluginEditor/styles.css
// module id = 507
// module chunks = 0